import React, { Component } from 'react';
import { toast } from 'react-toastify';
import { Button, Modal } from 'carbon-components-react';
import UnidAndStores from '../../../../components/trades/UnitsAndStores';
import { insertDmService, getDmService } from '../../../../services/Api';

class ConfirmExchangeUniform extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedUnit: null,
      selectedStore: null,
      stores: [],
      reason: null,
      modalConfirm: false,
      numberRequest: null,
    };
  }

  onChangeUnit = obj => {
    this.setState({
      selectedUnit: obj,
      selectedStore: null,
      // error: null,
    });

    if (obj) {
      this.loadStores(obj.id);
    }
  };

  onChangeStore = obj => {
    console.log('onChangeStore...');
    console.log(obj);
    this.setState({
      selectedStore: obj,
      // error: null,
    });
  };

  loadStores = async unitId => {
    const { cleark } = this.props;
    try {
      const data = await getDmService(`/Atendente/GetLojas/${cleark.id}?idUnidade=${unitId}`);
      const arrStores = [];
      data.forEach(item => {
        arrStores.push({
          id: item.id,
          label: item.nome,
        });
      });

      this.setState({
        stores: arrStores,
      });
    } catch (error) {
      console.error(error);
    }
  };

  getReason = value => {
    console.log(value);
    this.setState({
      reason: value,
    });
  };

  postUniform() {
    const { selectedUnit, selectedStore, reason } = this.state;
    if (selectedUnit && selectedStore && reason) {
      const { dataUniforms, cleark, orderId } = this.props;
      const urlEdit = '/Pedido/GeraPedidoMaterial';

      const formData = {
        TipoCadastro: { id: 4 },
        TipoAssistente: { id: 1 },
        Atendente: { Id: cleark.id },
        Produto: 1,
        PedidoPai: orderId,
        Motivo: 1,
        Unidade: { Id: selectedUnit.id },
        Loja: { Id: selectedStore.id },
        TamanhoCamisetaTroca: dataUniforms.tamanhoCamiseta,
        TamanhoCamisetaTroca2: dataUniforms.tamanhoCamiseta2,
        TamanhoCamisetaTroca3: dataUniforms.tamanhoCamiseta3,
        TamanhoAgasalhoTroca: dataUniforms.tamanhoAgasalho,
        TamanhoCamiseta: dataUniforms.tamanhoCamiseta,
        TamanhoCamiseta2: dataUniforms.tamanhoCamiseta2,
        TamanhoCamiseta3: dataUniforms.tamanhoCamiseta3,
        TamanhoAgasalho: dataUniforms.tamanhoAgasalho,
        MotivoTroca: reason,
      };

      insertDmService(urlEdit, formData)
        .then(res => {
          this.setState({ numberRequest: res });
          this.openModal();
        })
        .catch(err => {
          toast.warn('Um erro inesperado ocorreu. Tente novamente mais tarde.');
          console.log(err);
        });
    } else {
      toast.warn('Por favor verifique se todos os campos estão preenchidos.');
    }
  }

  openModal = () => {
    this.setState({ modalConfirm: true });
  };

  closeModal = () => {
    this.setState({ modalConfirm: false });
    this.returnSearchTrades();
  };

  returnSearchTrades = () => {
    window.location.href = '/trade/uniformes';
  };

  render() {
    const { selectedUnit, selectedStore, stores, modalConfirm, numberRequest } = this.state;
    const { dataUniforms, cleark, showProps, valueOrigins, returnConfirm } = this.props;
    return (
      <div>
        <div className="bx--row">
          <div className="bx--col-xs-8">
            <p className="description-option-title ">Confirme sua Troca</p>
            <p className="description-option-desc">
              Você tem certeza que deseja trocar os itens abaixo?
            </p>
          </div>

          <div className="bx--col-xs-12">
            <div className="mg-top-40 confirm-troca">
              {showProps.tamanhoCamiseta && (
                <p className="mg-top-20 color-red">
                  <strong>Camiseta </strong>
                  {' '}
                  <span className="line-through">
                    {' '}
                    {valueOrigins.tamanhoCamiseta}
                    {' '}
                  </span>
                </p>
              )}
              {showProps.tamanhoCamiseta2 && (
                <p className="mg-top-20 color-red">
                  <strong>Camiseta </strong>
                  {' '}
                  <span className="line-through">
                    {' '}
                    {valueOrigins.tamanhoCamiseta2}
                    {' '}
                  </span>
                </p>
              )}
              {showProps.tamanhoCamiseta3 && (
                <p className="mg-top-20 color-red">
                  <strong>Camiseta </strong>
                  {' '}
                  <span className="line-through">
                    {' '}
                    {valueOrigins.tamanhoCamiseta3}
                    {' '}
                  </span>
                </p>
              )}
              {showProps.tamanhoAgasalho && (
                <p className="mg-top-20 color-red">
                  <strong>Agasalho </strong>
                  {' '}
                  <span className="line-through">
                    {' '}
                    {valueOrigins.tamanhoAgasalho}
                    {' '}
                  </span>
                </p>
              )}
              <p className="mg-top-20">por</p>
              {showProps.tamanhoCamiseta && (
                <p className="mg-top-20 color-green">
                  <strong>Camiseta </strong>
                  {' '}
                  <span>
                    {' '}
                    {dataUniforms.tamanhoCamiseta}
                    {' '}
                  </span>
                </p>
              )}
              {showProps.tamanhoCamiseta2 && (
                <p className="mg-top-20  color-green">
                  <strong>Camiseta </strong>
                  {' '}
                  <span>
                    {' '}
                    {dataUniforms.tamanhoCamiseta2}
                    {' '}
                  </span>
                </p>
              )}
              {showProps.tamanhoCamiseta3 && (
                <p className="mg-top-20 color-green">
                  <strong>Camiseta </strong>
                  {' '}
                  <span>
                    {' '}
                    {dataUniforms.tamanhoCamiseta3}
                    {' '}
                  </span>
                </p>
              )}
              {showProps.tamanhoAgasalho && (
                <p className="mg-top-20 color-green">
                  <strong>Agasalho </strong>
                  {' '}
                  <span>
                    {' '}
                    {dataUniforms.tamanhoAgasalho}
                    {' '}
                  </span>
                </p>
              )}
              <div className="bx--form-item mg-top-40">
                <textarea
                  id="text-area-2"
                  className="bx--text-area"
                  onChange={e => this.getReason(e.target.value)}
                  rows="4"
                  cols="50"
                  placeholder="Digite aqui"
                />
                <label htmlFor="text-area-2" className="bx--label">
                  {' '}
                  Motivo da Troca
                  {' '}
                </label>
              </div>
              <div className="stores-units-trades">
                <h2>Qual a loja principal deste atendente.</h2>
                <p>
                  Selecione abaixo a loja principal de
                  {' '}
                  <span>
                    {' '}
                    {cleark.label}
                    {' '}
                  </span>
                </p>
                <div className="mg-top-20">
                  <UnidAndStores
                    onChangeStore={this.onChangeStore}
                    onChangeUnit={this.onChangeUnit}
                    urlUnits={`/Atendente/GetUnidades/${cleark.id}`}
                    stores={stores}
                    selectedUnit={selectedUnit}
                    selectedStore={selectedStore}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="bx--row">
          <div className="bx--col-xs-12 v-md-margin buttons-footer-requests">
            <Button onClick={() => this.postUniform()}> Confirmar </Button>
            <Button onClick={returnConfirm} kind="ghost" className="h-sm-margin">
              Voltar
            </Button>
          </div>
        </div>

        <Modal
          onRequestClose={() => this.closeModal()}
          onRequestSubmit={() => this.closeModal()}
          iconDescription="Fechar"
          className="some-class confirm-trade"
          open={modalConfirm}
          modalHeading="Pedido feito com sucesso."
          primaryButtonText="Ok, Entendi"
          secondaryButtonText="aaa"
        >
          <div className="warning-modal-txt">
            <p>
              <strong>
                {`Seu pedido ${numberRequest} está sob avaliação.`}
              </strong>
            </p>
            <p className="finalizado-pedido">
              A qualquer momento você poderá acompanhá-lo clicando no ícone
              {' '}
              <a className="notifications pointer" href="/pedidos">
                <i className="assignment" />
              </a>
              {' '}
              <br />
              disponível no canto superior da sua tela.
            </p>
          </div>
        </Modal>
      </div>
    );
  }
}

export default ConfirmExchangeUniform;



// WEBPACK FOOTER //
// ./src/screens/client/trades/uniforms/ConfirmExchangeUniform.jsx